"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
// Import Table Styles
const TableRow_styles_1 = require("./TableRow.styles");
const Tooltip_1 = require("../Tooltip/Tooltip");
const StyledTableRow = ({ onClick, height, cells, columns, sortedColumnIndex, sortDirection, }) => {
    const [sortKey, setSortKey] = (0, react_1.useState)(`${sortedColumnIndex}_${sortDirection}`);
    const [isSortAnimating, setIsSortAnimating] = (0, react_1.useState)(false);
    (0, react_1.useEffect)(() => {
        if (`${sortedColumnIndex}_${sortDirection}` !== sortKey) {
            setSortKey(`${sortedColumnIndex}_${sortDirection}`);
            setIsSortAnimating(true);
        }
    }, [sortedColumnIndex, sortDirection]);
    return (react_1.default.createElement(TableRow_styles_1.StyledTableRowContainer, { onClick: onClick, height: height }, cells.map((cell, index) => {
        const cellAlignment = cell.alignment ||
            columns[index].alignment ||
            (typeof cell.content === 'string' && cell.content.startsWith('$')
                ? 'right'
                : 'left');
        return (react_1.default.createElement(TableRow_styles_1.StyledTableRowCell, { key: `${columns[index].key}-${index}`, columnIndex: index, width: columns[index].width, alignment: cellAlignment, sortedColumnIndex: sortedColumnIndex, isSortAnimating: isSortAnimating, onAnimationEnd: () => setIsSortAnimating(false) }, cell.toolTipText ? (react_1.default.createElement("div", { style: { display: 'inline-block', width: 'auto' } },
            react_1.default.createElement(Tooltip_1.Tooltip, { title: cell.toolTipText, placement: 'top' }, cell.content || '-'))) : (cell.content || '-')));
    })));
};
exports.default = StyledTableRow;
//# sourceMappingURL=TableRow.js.map